import React, { useContext } from "react";
import { AuthContext } from "../../API/AuthContext";

export default function FlashMessage() {
  const [, , , , flashMessage, , , ,] = useContext(AuthContext);

  return (
    <div
      aria-hidden={flashMessage.show ? "true" : "false"}
      className={`alert ${flashMessage.show ? "show" : ""} alert-${
        flashMessage.type
      } w-75 center-fixed text-center font-weight-bold`}
      role="alert"
    >
      {flashMessage.msg}
    </div>
  );
}
